import React, { Component } from 'react';
import './CustomSelect.css';

export class CustomSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      searchQuery: '',
    };
    this.containerRef = React.createRef();
    this.searchInputRef = React.createRef();
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    if (this.containerRef.current && !this.containerRef.current.contains(event.target)) {
      this.setState({ isOpen: false, searchQuery: '' });
    }
  };

  toggleDropdown = () => {
    if (this.props.disabled) return;
    this.setState((prevState) => {
      const nextOpen = !prevState.isOpen;
      if (nextOpen) {
        // Focus the search input shortly after opening
        setTimeout(() => {
          if (this.searchInputRef.current) {
            this.searchInputRef.current.focus();
          }
        }, 50);
      }
      return { isOpen: nextOpen, searchQuery: '' };
    });
  };

  handleOptionClick = (optionValue) => {
    const { mode, value, onChange } = this.props;
    if (mode === 'multiple') {
      const currentValue = Array.isArray(value) ? value : [];
      let newValue;
      if (currentValue.includes(optionValue)) {
        newValue = currentValue.filter(val => val !== optionValue);
      } else {
        newValue = [...currentValue, optionValue];
      }
      if (onChange) {
        onChange(newValue);
      }
    } else {
      this.setState({ isOpen: false, searchQuery: '' });
      if (onChange) {
        onChange(optionValue);
      }
    }
  };

  handleRemoveOption = (optionValue, e) => {
    e.stopPropagation();
    const { value, onChange } = this.props;
    const currentValue = Array.isArray(value) ? value : [];
    const newValue = currentValue.filter(val => val !== optionValue);
    if (onChange) {
      onChange(newValue);
    }
  };

  handleSearchChange = (e) => {
    this.setState({ searchQuery: e.target.value });
  };

  render() {
    const { options = [], value, placeholder, disabled, style, showSearch, mode } = this.props;
    const { isOpen, searchQuery } = this.state;
    const isMultiple = mode === 'multiple';

    // Filter options based on search query
    const filteredOptions = options.filter((opt) => {
      if (!searchQuery) return true;
      const labelStr = opt.label ? String(opt.label).toLowerCase() : '';
      return labelStr.includes(searchQuery.toLowerCase());
    });

    let displayContent;
    let hasValue = false;

    if (!isMultiple) {
      return (
        <select
          disabled={disabled}
          style={{
            width: "100%",
            padding: "4px 11px",
            borderRadius: "4px",
            border: "1px solid #d9d9d9",
            backgroundColor: "#fff",
            outline: "none",
            cursor: "pointer",
            height: "32px",
            boxSizing: "border-box",
            ...style
          }}
          value={value || ""}
          onChange={(e) => {
            if (this.props.onChange) {
              this.props.onChange(e.target.value);
            }
          }}
        >
          {placeholder && <option value="" disabled>{placeholder}</option>}
          {options.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      );
    }

    if (isMultiple) {
      const currentValue = Array.isArray(value) ? value : [];
      const selectedOptions = options.filter((opt) => currentValue.includes(opt.value));
      hasValue = selectedOptions.length > 0;

      if (hasValue) {
        displayContent = (
          <div className="custom-select-tags-container">
            {selectedOptions.map((opt) => (
              <span className="custom-select-tag" key={opt.value}>
                <span className="custom-select-tag-label">{opt.label}</span>
                <span 
                  className="custom-select-tag-close" 
                  onClick={(e) => this.handleRemoveOption(opt.value, e)}
                >
                  &times;
                </span>
              </span>
            ))}
          </div>
        );
      } else {
        displayContent = <span className="custom-select-value placeholder">{placeholder || 'Select...'}</span>;
      }
    } else {
      const selectedOption = options.find((opt) => opt.value === value);
      hasValue = !!selectedOption;
      const displayLabel = selectedOption ? selectedOption.label : (placeholder || 'Select...');
      displayContent = (
        <span className={`custom-select-value ${!selectedOption ? 'placeholder' : ''}`}>
          {displayLabel}
        </span>
      );
    }

    return (
      <div 
        ref={this.containerRef} 
        className={`custom-select-container ${disabled ? 'disabled' : ''} ${isOpen ? 'open' : ''} ${isMultiple ? 'multiple' : ''}`}
        style={style}
      >
        <div className="custom-select-trigger" onClick={this.toggleDropdown}>
          {displayContent}
          <span className="custom-select-arrow">
            <svg width="10" height="6" viewBox="0 0 10 6" fill="none">
              <path d="M1 1L5 5L9 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </span>
        </div>

        {isOpen && (
          <div className="custom-select-dropdown">
            {showSearch && (
              <div className="custom-select-search-container" onClick={(e) => e.stopPropagation()}>
                <input
                  ref={this.searchInputRef}
                  type="text"
                  className="custom-select-search-input"
                  placeholder="Search..."
                  value={searchQuery}
                  onChange={this.handleSearchChange}
                />
              </div>
            )}
            <div className="custom-select-options-list">
              {filteredOptions.map((opt) => {
                const isSelected = isMultiple 
                  ? (Array.isArray(value) && value.includes(opt.value))
                  : opt.value === value;
                return (
                  <div
                    key={opt.value}
                    className={`custom-select-option ${isSelected ? 'selected' : ''}`}
                    onClick={() => this.handleOptionClick(opt.value)}
                  >
                    {isMultiple && (
                      <span className={`custom-select-checkbox ${isSelected ? 'checked' : ''}`}>
                        {isSelected && '✓'}
                      </span>
                    )}
                    <span className="custom-select-option-label">{opt.label}</span>
                  </div>
                );
              })}
              {filteredOptions.length === 0 && (
                <div className="custom-select-no-data">No results found</div>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}
